import {
    FETCH_INSIGHT_DATA,
    FETCH_INSIGHT_DATA_FETCHING,
    FETCH_INSIGHT_DATA_SUCCESS,
    FETCH_INSIGHT_DATA_FAIL,
    UPDATE_INSIGHT_STATUS,
    UPDATE_INSIGHT_STATUS_UPDATING,
    UPDATE_INSIGHT_STATUS_SUCCESS,
    UPDATE_INSIGHT_STATUS_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    data: {},
    insightDataFetching: {},
    insightDataFetchFail: {},
    insightStatusUpdating: {},
    insightStatusUpdateFail: {}
};

// ======= Fetching Handlers =======
const fetchInsightDataFetching = (state, action) => {
    return {
        ...state,
        data: {
            ...state.data,
            [action.createdDateUTC]: {}
        },
        insightDataFetching: {
            ...state.insightDataFetching,
            [action.createdDateUTC]: true
        },
        insightDataFetchFail: {
            ...state.insightDataFetchFail,
            [action.createdDateUTC]: false
        }
    };
};

const fetchInsightDataSuccess = (state, action) => {
    return {
        ...state,
        data: {
            ...state.data,
            [action.createdDateUTC]: action.data
        },
        insightDataFetching: {
            ...state.insightDataFetching,
            [action.createdDateUTC]: false
        },
        insightDataFetchFail: {
            ...state.insightDataFetchFail,
            [action.createdDateUTC]: false
        }
    };
};

const fetchInsightDataFail = (state, action) => {
    return {
        ...state,
        data: {
            ...state.data,
            [action.createdDateUTC]: null
        },
        insightDataFetching: {
            ...state.insightDataFetching,
            [action.createdDateUTC]: false
        },
        insightDataFetchFail: {
            ...state.insightDataFetchFail,
            [action.createdDateUTC]: true
        }
    };
};

// ======= Updating Handlers =======
// Note, there can be multiple Insights and both the Insight FeedbackForm and the "Delete Insight" button of each Insight call the same endpoint to update the Insight's status
// -> to handle the loading and error flags, the createdDateUTC and a flagId is passed in on the action to differentiate them
const updateInsightStatusUpdating = (state, action) => {
    return {
        ...state,
        insightStatusUpdating: {
            ...state.insightStatusUpdating,
            [action.createdDateUTC]: {
                ...state[action.createdDateUTC],
                [action.flagId]: true
            }
        },
        insightStatusUpdateFail: {
            ...state.insightStatusUpdateFail,
            [action.createdDateUTC]: {
                ...state[action.createdDateUTC],
                [action.flagId]: false
            }
        }
    };
};

const updateInsightStatusSuccess = (state, action) => {
    return {
        ...state,
        insightStatusUpdating: {
            ...state.insightStatusUpdating,
            [action.createdDateUTC]: {
                ...state[action.createdDateUTC],
                [action.flagId]: false
            }
        },
        insightStatusUpdateFail: {
            ...state.insightStatusUpdateFail,
            [action.createdDateUTC]: {
                ...state[action.createdDateUTC],
                [action.flagId]: false
            }
        }
    };
};

const updateInsightStatusFail = (state, action) => {
    return {
        ...state,
        insightStatusUpdating: {
            ...state.insightStatusUpdating,
            [action.createdDateUTC]: {
                ...state[action.createdDateUTC],
                [action.flagId]: false
            }
        },
        insightStatusUpdateFail: {
            ...state.insightStatusUpdateFail,
            [action.createdDateUTC]: {
                ...state[action.createdDateUTC],
                [action.flagId]: true
            }
        }
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_INSIGHT_DATA_FETCHING]: fetchInsightDataFetching,
    [FETCH_INSIGHT_DATA_SUCCESS]: fetchInsightDataSuccess,
    [FETCH_INSIGHT_DATA_FAIL]: fetchInsightDataFail,
    [UPDATE_INSIGHT_STATUS_UPDATING]: updateInsightStatusUpdating,
    [UPDATE_INSIGHT_STATUS_SUCCESS]: updateInsightStatusSuccess,
    [UPDATE_INSIGHT_STATUS_FAIL]: updateInsightStatusFail
};

// ======= Default Action =======
export default function insightData(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchInsightData(featureId, createdDateUTC, lang, evictCache) {
    return {
        type: FETCH_INSIGHT_DATA,
        featureId,
        createdDateUTC,
        lang,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

export function updateInsightStatus(newStatus, createdDateUTC, featureId, flagId) {
    return {
        type: UPDATE_INSIGHT_STATUS,
        newStatus: newStatus,
        createdDateUTC: createdDateUTC,
        featureId: featureId,
        flagId: flagId
    };
}

// ======= Selectors =======
export const getInsightData = (state, createdDateUTC) => {
    return state.insightData.data[createdDateUTC] ? state.insightData.data[createdDateUTC] : null;
};

export const isInsightDataFetching = (state, createdDateUTC) => {
    return state.insightData.insightDataFetching && state.insightData.insightDataFetching[createdDateUTC]
        ? state.insightData.insightDataFetching[createdDateUTC]
        : null;
};

export const didInsightDataFetchFail = (state, createdDateUTC) => {
    return state.insightData.insightDataFetchFail && state.insightData.insightDataFetchFail[createdDateUTC]
        ? state.insightData.insightDataFetchFail[createdDateUTC]
        : null;
};

export const isInsightStatusUpdateUpdating = (state, createdDateUTC, flagId) => {
    return state.insightData.insightStatusUpdating &&
        state.insightData.insightStatusUpdating[createdDateUTC] &&
        state.insightData.insightStatusUpdating[createdDateUTC][flagId]
        ? state.insightData.insightStatusUpdating[createdDateUTC][flagId]
        : null;
};

export const didInsightStatusUpdateFail = (state, createdDateUTC, flagId) => {
    return state.insightData.insightStatusUpdateFail &&
        state.insightData.insightStatusUpdateFail[createdDateUTC] &&
        state.insightData.insightStatusUpdateFail[createdDateUTC][flagId]
        ? state.insightData.insightStatusUpdateFail[createdDateUTC][flagId]
        : null;
};
